/**
 * 鷹架節點標籤的介面樣式（summary / compare / question / insight / expand）
 * 用於在 StickerWorkspace 中以顏色與標籤徽章區分不同類型節點
 */
export const SCAFFOLD_TAG_STYLES = {
  summary: {
    label: '摘要',
    emoji: '📝',
    backgroundColor: '#e8f5e9',
    borderColor: '#4caf50',
    badgeColor: '#2e7d32',
  },
  compare: {
    label: '比較',
    emoji: '⚖️',
    backgroundColor: '#f3e5f5',
    borderColor: '#9c27b0',
    badgeColor: '#6a1b9a',
  },
  question: {
    label: '提問',
    emoji: '❓',
    backgroundColor: '#fff3e0',
    borderColor: '#ff9800',
    badgeColor: '#e65100',
  },
  insight: {
    label: '洞察',
    emoji: '💡',
    backgroundColor: '#fce4ec',
    borderColor: '#e91e63',
    badgeColor: '#c2185b',
  },
  expand: {
    label: '延伸',
    emoji: '🚀',
    backgroundColor: '#ede7f6',
    borderColor: '#673ab7',
    badgeColor: '#512da8',
  },
  questionnaire: {
    label: '問卷',
    emoji: '📋',
    backgroundColor: '#D1FAE5',
    borderColor: '#10b981',
    badgeColor: '#065f46',
  },
};

/** 是否為鷹架標籤（用於判斷是否套用特殊樣式） */
export const isScaffoldTag = (tag) =>
  tag && typeof tag === 'string' && Object.prototype.hasOwnProperty.call(SCAFFOLD_TAG_STYLES, tag);
